export default __webpack_public_path__ + "static/media/clouds_inspire.e4377a4d.webp";